import React from "react";
import tw, { styled } from "twin.macro";
import { StaticImage } from "gatsby-plugin-image";

const Button = styled.div`
  ${tw`absolute z-20 flex items-center justify-center transform -translate-y-1/2`}
  * {
    ${tw`!mb-0`}; /* need to over-ride the rule from content */
  }
`;

const Outter = styled.div`
  ${tw` absolute w-48 h-48 overflow-hidden rounded-full`}
  img {
    ${tw`!object-contain`}
  }
  animation: spin 60s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Inner = styled.div`
  ${tw`absolute w-16 h-16 ml-4`}
  .gatsby-image-wrapper {
    img {
      ${tw`!object-contain`}
    }
  }
`;

const PlayButton = ({ ...rest }) => {
  return (
    <Button {...rest}>
      <Outter className="text">
        <StaticImage
          src="../images/play-text.png"
          alt="Play Video"
          className="play-text"
          quality={100}
        />
      </Outter>
      <Inner>
        <StaticImage
          className="icon"
          src="../images/play-button.png"
          alt="Play Video"
          quality={100}
        />
      </Inner>
    </Button>
  );
};

export default PlayButton;
